import type { Step } from '../Config';

/**
 * Search step number based on step key
 * step number = step index + 1
 *
 * @param {Step<TData>[]} steps
 * @param {keyof TData} key
 * @return {number}
 */
export function findStepNumber<TData>(steps: Step<TData>[], key: keyof TData): number {
    const index = steps.findIndex((step) => step.key === key);

    return index === -1 ? 0 : index + 1;
}
